import React, { FunctionComponent } from "react";

interface CreditCardIconProps {
  color?: string;
  size?: string;
}

const CreditCardIcon: FunctionComponent<CreditCardIconProps> = ({
  color = "#2F373D",
  size = "40",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5909 4H3.40909C2.35473 4 1.5 4.89543 1.5 6V18C1.5 19.1046 2.35473 20 3.40909 20H20.5909C21.6453 20 22.5 19.1046 22.5 18V6C22.5 4.89543 21.6453 4 20.5909 4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 8.5H22.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 7H22.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5.00049L21 6.00024"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 6.2998H18.75"
        stroke="#E9F7F3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CreditCardIcon;
